import SportContext from 'pages/Sport/_context/SportContext'
import contextConnector from 'helpers/contextConnectorV2'

export default contextConnector(SportContext)
